import { Injectable } from '@angular/core';

import { CalendarEventModification } from '@gfe/features/components/visualization/calendar/models/calendar.models';

@Injectable({ providedIn: 'root' })
export class CalendarModificationActionsService {
  private modifications = new Map<string, CalendarEventModification>();

  setModifications(map: Map<string, CalendarEventModification>): void {
    this.modifications = map;
  }

  getModification(uid: string): CalendarEventModification | undefined {
    return this.modifications.get(uid);
  }
}
